import React, { FC, useEffect, useState } from 'react'

import { Button, CircularProgress } from '@mui/material'

import {
	blockCoach,
	unblockCoach,
} from '../../../../../../store/reducers/coaches/actions'
import { useDefaultComponentTools } from '../../../../../../hooks/useDefaultComponentTools'

interface CoachActivateButtonProps {
	readonly coachId: string
	readonly isActive?: boolean
}

const CoachActivateButton: FC<CoachActivateButtonProps> = ({
	coachId,
	isActive,
}: CoachActivateButtonProps) => {
	const { dispatch, alert, isMounted, loading, setLoading } =
		useDefaultComponentTools()
	const [buttonLabel, setButtonLabel] = useState<string>(
		isActive ? 'Deactivate' : 'Activate'
	)

	useEffect(() => {
		const buttonLabel = isActive ? 'Deactivate' : 'Activate'

		setButtonLabel(buttonLabel)

		setLoading(false)
	}, [isActive])

	const handleClick: React.MouseEventHandler<
		HTMLButtonElement
	> = async () => {
		try {
			setLoading(true)

			if (isActive) {
				await dispatch(blockCoach(coachId))
			} else {
				await dispatch(unblockCoach(coachId))
			}
		} catch (e: any) {
			'message' in e && alert.error(e.message)

			isMounted() && setLoading(false)
		}
	}

	return (
		<Button
			variant={'contained'}
			size={'large'}
			onClick={handleClick}
			sx={{ my: 'auto' }}
			disabled={loading}
		>
			{loading && <CircularProgress size={28} color={'primary'} />}

			{!loading && buttonLabel}
		</Button>
	)
}

export default CoachActivateButton
